import { render } from "./RemoveAccount.vue?vue&type=template&id=32850a39"
import script from "./RemoveAccount.vue?vue&type=script&lang=js"
export * from "./RemoveAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__